<template>
    <App title="Engine">
        <Block>
            <template #header>
                <h3 class="block-title">Engine</h3>
            </template>
            <Datatable :options="options" />
        </Block>
    </App>
</template>

<script lang="ts">
import Block from '@/vue/components/Block.vue'
import Datatable from '@/vue/components/Datatable.vue'
import App from '@/vue/templates/App.vue'
import { CellRender, Column } from '@/vue/utils/Datatable'
import { Component, toNative, Vue } from 'vue-facing-decorator'

@Component({
    components: {
        App,
        Block,
        Datatable,
    },
})
class Group extends Vue {
    get buttons() {
        let buttons: any[] = []
        buttons.push('refresh')
        // buttons.push({
        //     extend: 'create',
        //     attr: {
        //         href: this.route('engine.page.create'),
        //     },
        // })
        buttons.push('trashed')

        return buttons
    }

    get columns() {
        let columns: any[] = []

		columns.push({
			data: 'serial',
			title: 'Serial Number',
			render: (data: string, _type: any, row: any) => {
				const label = row.financier ? 'Financier' : 'Swap'
				const color = row.financier ? 'secondary' : 'success'
				return `${data}<br><span class="badge bg-${color} mt-1">${label}</span>`
			},
		})
		
		columns.push({
			data: 'rider.fullname',
			title: 'Associated Rider',
			orderable: true,
			name: 'rider.fullname',
			
		})
		columns.push({
			data: 'allocation_status',
			title: 'Status',
			orderable: true,
			name: 'status',
		})
		

        columns.push({
            data: 'created_at',
            title: 'Registered',
            render: CellRender.date(),
            orderable: true,
            name: 'created_at',
        })

        columns.push(Column.actions(this.$gate, { view: false }))

        return columns
    }

    get options() {
        return {
            ajax: {
                url: this.route('engine.ajax.table'),
                method: 'POST',
            },
            buttons: this.buttons,
            columns: this.columns,
        }
    }
}
export default toNative(Group)
</script>
